import { memo } from 'react';
import { SecuritiesTableProps } from '@dealstack/frontend/app/pages/Valuations/views/SourcesAndUses/types';
import { SourcesUsesSecuritiesTable } from '@dealstack/frontend/app/pages/Valuations/views/SourcesAndUses/components/SourcesUsesSecuritiesTable';

export const ProceedsTable = memo(
	({ person, summary, baseCurrency, fxRates }: SecuritiesTableProps) => {
		return (
			<SourcesUsesSecuritiesTable
				person={person}
				summary={summary}
				baseCurrency={baseCurrency}
				fxRates={fxRates}
				variant="proceeds"
			/>
		);
	},
	(prevProps, nextProps) => {
		const isPersonSame = prevProps.person.id === nextProps.person.id;
		const isSummaryRefSame = prevProps.summary === nextProps.summary;
		const isBaseCurrencySame = prevProps.baseCurrency === nextProps.baseCurrency;
		const areFxRatesSame = prevProps.fxRates === nextProps.fxRates;

		return isPersonSame && isSummaryRefSame && isBaseCurrencySame && areFxRatesSame;
	}
);
